import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ESignatureService } from '@cl/core/services/e-signature.service';
import { ESignFlow } from '@cl/shared/models/e-signature/e-sign-flow.model';
import { ESignatureFlow } from '@cl/shared/models/e-signature/e-signature-flow.enum';
import { ESignatureLocalStorageKeys } from '@cl/shared/models/e-signature/e-signature-local-storage-keys.enum';
import { ESignatureSignableFileType } from '@cl/shared/models/e-signature/e-signature-signable-file-type.enum';
import { ESignatureStep } from '@cl/shared/models/e-signature/e-signature-step.enum';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-e-sign-flow-select',
    templateUrl: './e-sign-flow-select.component.html',
    styleUrl: './e-sign-flow-select.component.less',
    standalone: false,
})
export class ESignFlowSelectComponent {
    // Šim plūsmas veidam serveris failu sagatavo tikai parakstīšanas sākumā.
    private readonly signableFileTypesWithoutFileIds: string[] = [ESignatureSignableFileType.HR_DOCUMENT_ACK];

    fileIds: number[];
    signableFileType: string;
    mergeMode: boolean = false;

    documentId: number;
    expenseRequestId: number;
    expenseId: number;
    fuelReportId: number;
    hrDocumentAcknowledgementId: number;

    availableFlows: ESignFlow[] = [
        {
            title: 'eParaksts Mobile',
            imgLocation: '../../../../../assets/img/e-sign/eMobile.png',
            acrValue: ESignatureFlow.MOBILE,
        },
        {
            title: 'eID karte vai eParaksts karte',
            imgLocation: '../../../../../assets/img/e-sign/eparaksts_eID_Karte.png',
            acrValue: ESignatureFlow.CARD,
        },
    ];

    constructor(
        private router: Router,
        private eSignatureService: ESignatureService,
        private msgService: NzMessageService,
        private modal: NzModalRef,
    ) {}

    async selectFlow(flow: ESignFlow): Promise<void> {
        const hasSignableSource: boolean = this.signableFileTypesWithoutFileIds.includes(this.signableFileType)
            ? !!this.hrDocumentAcknowledgementId
            : !!this.fileIds && this.fileIds.length > 0;

        if (!hasSignableSource) {
            this.msgService.error(`Neizdevās uzsākt parakstīšanu`);
            this.modal.destroy();
            throw Error('FileId or FileIds must be set!');
        }

        let params: HttpParams = new HttpParams()
            .append('fileIds', (this.fileIds ?? []).toString())
            .append('acrValue', flow.acrValue)
            .append('returnRoute', this.router.url)
            .append('signableFileType', this.signableFileType)
            .append('mergeMode', this.mergeMode);

        if (this.signableFileType == ESignatureSignableFileType.DOCUMENT && this.documentId) {
            params = params.append('documentId', this.documentId);
        }

        if (this.signableFileType == ESignatureSignableFileType.EXPENSE_REQUEST_APPROVAL && this.expenseRequestId) {
            params = params.append('expenseRequestId', this.expenseRequestId);
        }

        if (this.signableFileType == ESignatureSignableFileType.EXPENSE_FILE && this.expenseId) {
            params = params.append('expenseId', this.expenseId);
        }

        if (this.signableFileType == ESignatureSignableFileType.FUEL_REPORT_APPROVAL && this.fuelReportId) {
            params = params.append('fuelReportId', this.fuelReportId);
        }

        if (this.signableFileType == ESignatureSignableFileType.HR_DOCUMENT_ACK && this.hrDocumentAcknowledgementId) {
            params = params.append('hrDocumentAcknowledgementId', this.hrDocumentAcknowledgementId);
        }

        localStorage.setItem(ESignatureLocalStorageKeys.RETURN_ROUTE, this.router.url);
        localStorage.setItem(ESignatureLocalStorageKeys.FLOW, flow.acrValue);
        localStorage.setItem(ESignatureLocalStorageKeys.STEP, ESignatureStep.INIT);

        try {
            const url = (await this.eSignatureService.getSigningFlowUrl(params)).data;
            window.open(url, '_self');
        } catch (ex) {
            this.eSignatureService.clearESignatureLocalStorageValues();
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach((error) => {
                    this.msgService.error(error);
                });
                this.modal.destroy();
                return;
            }

            this.msgService.error(`Neizdevās uzsākt parakstīšanu`);
            this.modal.destroy();
            return;
        }
    }
}
